//utilities import
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import APIURL from "../APIURL";
import useSWR from "swr";
import axios from "axios";
import { Prompt } from "react-router-dom";
import moment from "moment";

//kendo elements
import { Dialog } from "@progress/kendo-react-dialogs";
import { RadioButton } from "@progress/kendo-react-inputs";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Button } from "@progress/kendo-react-buttons";
import { Loader } from "@progress/kendo-react-indicators";
import { SvgIcon } from "@progress/kendo-react-common";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { Fade } from "@progress/kendo-react-animation";
import {
  Notification,
  NotificationGroup,
} from "@progress/kendo-react-notification";
import { pencilIcon, trashIcon, downloadIcon } from "@progress/kendo-svg-icons";
import {
  Grid as GridTelerik,
  GridColumn as Column,
  GridToolbar,
} from "@progress/kendo-react-grid";
import { Card, CardHeader } from "@progress/kendo-react-layout";

//localization
import { useLocalization } from "@progress/kendo-react-intl";
import {
  FormCheckbox,
  RequiredFormDatePicker,
  RequiredFormNumericTextBox,
  RequiredFormTextArea,
  RequiredFormInput,
} from "../common/Kendo/form-components";

import {
  requiredValidator,
  bloodpressureValidator,
} from "../common/Kendo/validators";

//component
import ApproveStudySubject from "../studysubject/ApproveStudySubject";
import TrialMap from "../studysubject/TrialMap";
import TabChange from "../common/commoncomponents/TabChange";
import AddFile from "../common/commoncomponents/AddFile";
import PermissionDenied from "../common/commoncomponents/PermissionDenied";
import DeleteObject from "../common/commoncomponents/DeleteObject";
import AddNote from "../common/commoncomponents/AddNote";
import GlobalNotificationTimer from "../common/commoncomponents/GlobalNotificationTimer";

export function ListVitalSigns(props) {
  //redux
  const UserDetail = useSelector((state) => state.UserDetail);
  const EditSubject = useSelector((state) => state.EditSubject);

  //localization
  const localizationService = useLocalization();

  const [approvedformchanged, setapprovedformchanged] = useState(false);

  //variables
  const MyForm = React.createRef(); //form ref to detect modification of the form
  const [EditNote, setEditNote] = useState([]); //to transfer data  edit note
  const [radioValue, setradioValue] = useState("no");

  //tooltip
  const TooltipContentTemplate = (props) => {
    return (
      <div className="custom-tooltip">
        <strong>{props.title}</strong>
      </div>
    );
  };

  //Dialog for tabstrip change
  const [selectedTab, setSelectedTab] = useState(null);
  const [VTabStripChange, setVTabStripChange] = useState(false);

  const toggleDTabStripChange = () => {
    setVTabStripChange(!VTabStripChange);
  };

  //callback function to send state from child to parent
  const TabCallBack = (value) => {
    setSelected(value);
    setapprovedformchanged(false);
  };

  //Permission dialog
  const [VPermission, setVPermission] = useState(false);

  const toggleDPermission = () => {
    setVPermission(!VPermission);
  };

  //dialog for deleting object
  const [DeleteAPI, setDeleteAPI] = useState("");
  const [Name, setName] = useState("");
  const [Vdelete, setVdelete] = useState(false);

  const toggleDdelete = () => {
    setVdelete(!Vdelete);
  };

  //dialog for adding and updating files :
  const [VaddFile, setVaddFile] = useState(false);

  const toggleDaddFile = () => {
    setVaddFile(!VaddFile);
  };

  //dialog for adding and updating and deleting notes
  const [VaddNote, setVaddNote] = useState(false);

  const toggleDaddNote = () => {
    setVaddNote(!VaddNote);
  };
  const [VeditNote, setVeditNote] = useState(false);

  const toggleDeditNote = () => {
    setVeditNote(!VeditNote);
  };

  //date template
  const DateCreatedTemplate = (dataItem) => {
    return (
      <td>
        {moment(dataItem.dataItem.date_created).format("YYYY-MM-DD HH:mm")}
      </td>
    );
  };
  //NoteNameTemplate
  const NoteNameTemplate = (dataItem) => {
    return dataItem.dataItem.note.length > 20 ? (
      <td style={{ cursor: "pointer" }}>
        <Tooltip
          openDelay={0}
          tooltipStyle={{
            width: "200px",
            textAlign: "center",
          }}
          content={(props) => <TooltipContentTemplate title={props.title} />}
          anchorElement="target"
          position="top"
          parentTitle={true}
        >
          <div title={dataItem.dataItem.note}>
            {dataItem.dataItem.note.slice(0, 20)}
            {"..."}
          </div>
        </Tooltip>
      </td>
    ) : (
      <td>
        {" "}
        <div>{dataItem.dataItem.note}</div>
      </td>
    );
  };

  //NOTE ACTIONS
  const Noteactions = (dataItem) => {
    return (
      <td>
        <div className="row">
          <div className="col-6">
            <SvgIcon
              className="EditActionButtons"
              icon={pencilIcon}
              onClick={() => {
                setEditNote(dataItem.dataItem);
                toggleDeditNote();
              }}
            />
          </div>
          <div className="col-6">
            <SvgIcon
              className="DeleteActionButtons"
              icon={trashIcon}
              onClick={() => {
                setDeleteAPI(`/common/updatenote/${dataItem.dataItem.id}/`);
                setName(dataItem.dataItem.note);
                toggleDdelete();
              }}
            />
          </div>
        </div>
      </td>
    );
  };

  //Modification Reason Dialog
  const [VModifyreason, setVModifyreason] = useState(false);

  const toggleDModifyreason = () => {
    setVModifyreason(!VModifyreason);
  };

  //data
  const fetcher1 = (url) =>
    axios
      .get(url, {
        params: {
          subject: props.location.state.data.id,
        },
      })
      .then((res) => res.data);
  const { data, error } = useSWR(
    props.location.state
      ? [
          APIURL + "/opera/baseline/addvitalsigns/",
          props.location.state.data.id,
        ]
      : null,
    fetcher1
  );

  const fetcher2 = (url) =>
    axios
      .get(url, {
        params: {
          subject: props.location.state.data.id,
          section: props.location.state.section.id,
        },
      })
      .then((res) => res.data);
  const { data: notes, Noteserror } = useSWR(
    props.location.state
      ? [
          APIURL + "/common/listnote/",
          props.location.state.data.id,
          props.location.state.section.id,
        ]
      : null,
    fetcher2
  );

  const { data: checkapprove, checkapproveerror } = useSWR(
    props.location.state
      ? [
          APIURL + `/common/checkapprove/`,
          props.location.state.data.id,
          props.location.state.section.id,
        ]
      : null,
    fetcher2
  );

  //attachement data
  const fetcher4 = (url) =>
    axios
      .get(url, {
        params: {
          subject: props.location.state.data.id,
          section: props.location.state.section.id,
        },
      })
      .then((res) => res.data);

  const { data: attachements, Attchementserror } = useSWR(
    props.location.state
      ? [
          APIURL + "/common/listfile/",
          props.location.state.data.id,
          props.location.state.section.id,
        ]
      : null,
    fetcher4
  );

  //FILE RELATED ACTIONS
  const Fileactions = (dataItem) => {
    return (
      <td>
        <div className="row">
          <div className="col-6">
            <SvgIcon
              svgStyle={{ cursor: "pointer", color: "grey" }}
              icon={downloadIcon}
              onClick={() => {
                EditSubject
                  ? DownloadFile(dataItem.dataItem.id, dataItem.dataItem.title)
                  : toggleDPermission();
              }}
            />
          </div>
          <div className="col-6">
            <SvgIcon
              svgStyle={{ cursor: "pointer", color: "red" }}
              icon={trashIcon}
              onClick={() => {
                setDeleteAPI(`/common/updatefile/${dataItem.dataItem.id}/`);
                setName(dataItem.dataItem.title);
                EditSubject ? toggleDdelete() : toggleDPermission();
              }}
            />
          </div>
        </div>
      </td>
    );
  };

  const DownloadFile = (id, title) => {
    axios
      .get(APIURL + `/common/downloadfile/${id}/`, {
        responseType: "blob",
      })
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", title);
        document.body.appendChild(link);
        link.click();
      });
  };

  // Notification
  const [ErrorNotification, setErrorNotification] = useState("");
  const position = {
    topCenter: {
      top: 0,
      left: "50%",
      transform: "translateX(-50%)",
    },
  };

  const [state, setState] = React.useState({
    success: false,
    nosave: false,
    deleted: false,
    nomodify: false,
  });

  const onToggle = (flag) => setState({ ...state, [flag]: !state[flag] });

  const { success, nosave, deleted, nomodify } = state;

  //variable
  const [loading, setLoading] = useState(false);
  const [AllData, setAllData] = useState(null);
  const [approved, setApproved] = useState(false);

  useEffect(() => {
    if (data) {
      if (data.message === "no data") {
        setAllData(null);
      } else {
        setAllData(data);
        setradioValue(data.missing_field === true ? "yes" : "no");
      }
    }
    if (checkapprove) {
      console.log(checkapprove, "checkkk approvee");
      setApproved(checkapprove);
    }
  }, [data, checkapprove]);

  //goback function

  const goBack = (event) => {
    if (event.type === "click") {
      props.history.push("/crf/studysubject/list");
    }
  };
  const [ModifiedData, setModifiedData] = useState();

  const CreateVitalSigns = (dataItem) => {
    if (dataItem.isValid) {
      if (AllData) {
        if (dataItem.isModified) {
          setModifiedData(dataItem.values);
          toggleDModifyreason();
        } else {
          onToggle("nomodify");
          setLoading(false);
          setTimeout(() => {
            setState({ ...state, nomodify: false });
          }, GlobalNotificationTimer);
        }
      } else {
        setLoading(true);
        axios
          .post(APIURL + "/opera/baseline/addvitalsigns/", {
            created_by: UserDetail.id,
            study_subject: props.location.state.data.id,
            section: props.location.state.section.id,
            missing_field: radioValue,
            missing_field_reason: dataItem.values.missing_field_reason,
            assessment_date: dataItem.values.assessment_date
              ? moment(dataItem.values.assessment_date).format("YYYY-MM-DD")
              : null,
            height_missing: dataItem.values.height_missing,
            height_missing_reason: dataItem.values.height_missing_reason,
            height: dataItem.values.height ? dataItem.values.height : null,
            weight_missing: dataItem.values.weight_missing,
            weight_missing_reason: dataItem.values.weight_missing_reason,
            weight: dataItem.values.weight
              ? parseFloat(dataItem.values.weight)
              : null,
            pulse_missing: dataItem.values.pulse_missing,
            pulse_missing_reason: dataItem.values.pulse_missing_reason,
            pulse: dataItem.values.pulse ? dataItem.values.pulse : null,
            respiratory_missing: dataItem.values.respiratory_missing,
            respiratory_missing_reason:
              dataItem.values.respiratory_missing_reason,
            respiratory_rate: dataItem.values.respiratory_rate
              ? dataItem.values.respiratory_rate
              : null,
            bodytemp_missing_reason: dataItem.values.bodytemp_missing_reason,
            bodytemp_missing: dataItem.values.bodytemp_missing,
            body_temperature: dataItem.values.body_temperature
              ? parseFloat(dataItem.values.body_temperature)
              : null,
            bloodpressure_missing_reason:
              dataItem.values.bloodpressure_missing_reason,
            bloodpressure_missing: dataItem.values.bloodpressure_missing,
            blood_pressure: dataItem.values.blood_pressure,
          })
          .then((res) => {
            onToggle("success");
            setTimeout(() => {
              setState({ ...state, success: false });
              setLoading(false);
            }, GlobalNotificationTimer);
          })
          .catch((error) => {
            setErrorNotification(error.response.status);
            onToggle("nosave");
            setTimeout(() => {
              setState({ ...state, nosave: false });
              setLoading(false);
            }, GlobalNotificationTimer);
          });
      }
    }
  };

  //TAB STRIP
  const [selected, setSelected] = React.useState(0);

  const handleSelect = (e) => {
    if (selected === 1) {
      if (approvedformchanged === true) {
        setSelectedTab(e.selected);
        toggleDTabStripChange();
      } else {
        setSelected(e.selected);
      }
    } else if (
      MyForm.current &&
      Object.keys(MyForm.current.modified).length !== 0
    ) {
      setSelectedTab(e.selected);
      toggleDTabStripChange();
    } else {
      setSelected(e.selected);
    }
  };

  const ChangeApproveSection = (value) => {
    setapprovedformchanged(value);
  };

  const [Subselected, setSubSelected] = React.useState(0);

  const handleSubSelect = (e) => {
    setSubSelected(e.selected);
  };

  const handleRadio1Change = (e, formRenderProps) => {
    setradioValue(e.value);
    formRenderProps.onChange("missing_field_reason", { value: "" });
  };

  const handleRadio2Change = (e, formRenderProps) => {
    setradioValue(e.value);
    formRenderProps.onChange("assessment_date", { value: null });
    formRenderProps.onChange("height_missing", { value: false });
    formRenderProps.onChange("height_missing_reason", { value: "" });
    formRenderProps.onChange("height", { value: null });
    formRenderProps.onChange("weight_missing", { value: false });
    formRenderProps.onChange("weight_missing_reason", { value: "" });
    formRenderProps.onChange("weight", { value: null });
    formRenderProps.onChange("pulse_missing", { value: false });
    formRenderProps.onChange("pulse_missing_reason", { value: "" });
    formRenderProps.onChange("pulse", { value: null });
    formRenderProps.onChange("respiratory_missing", { value: false });
    formRenderProps.onChange("respiratory_missing_reason", { value: "" });
    formRenderProps.onChange("respiratory", { value: null });
    formRenderProps.onChange("bodytemp_missing", { value: false });
    formRenderProps.onChange("bodytemp_missing_reason", { value: "" });
    formRenderProps.onChange("body_temperature", { value: null });
    formRenderProps.onChange("bloodpressure_missing", { value: false });
    formRenderProps.onChange("bloodpressure_missing_reason", { value: "" });
    formRenderProps.onChange("blood_pressure", { value: null });
  };

  //CheckBox handle Change

  //prompt function to trigger any change
  const PromptFunction = (formRenderProps) => {
    let boolean = false;
    if (formRenderProps.modified) {
      boolean = true;
    } else {
      boolean = false;
    }

    return boolean;
  };

  const CreateModification = (dataItem) => {
    toggleDModifyreason(false);
    setLoading(true);
    axios
      .put(APIURL + "/opera/baseline/updatevitalsigns/" + AllData.id + "/", {
        modification_reason: dataItem.modification_reason,
        created_by: AllData.created_by,
        modified_by: UserDetail.id,
        study_subject: props.location.state.data.id,
        missing_field: radioValue,
        missing_field_reason: ModifiedData.missing_field_reason,
        section: props.location.state.section.id,
        assessment_date: ModifiedData.assessment_date
          ? moment(ModifiedData.assessment_date).format("YYYY-MM-DD")
          : null,
        height_missing: ModifiedData.height_missing,
        height_missing_reason: ModifiedData.height_missing_reason,
        height: ModifiedData.height ? ModifiedData.height : null,
        weight_missing: ModifiedData.weight_missing,
        weight_missing_reason: ModifiedData.weight_missing_reason,
        weight: ModifiedData.weight ? parseFloat(ModifiedData.weight) : null,
        pulse_missing: ModifiedData.pulse_missing,
        pulse_missing_reason: ModifiedData.pulse_missing_reason,
        pulse: ModifiedData.pulse ? ModifiedData.pulse : null,
        respiratory_missing: ModifiedData.respiratory_missing,
        respiratory_missing_reason: ModifiedData.respiratory_missing_reason,
        respiratory_rate: ModifiedData.respiratory_rate
          ? ModifiedData.respiratory_rate
          : null,
        bodytemp_missing_reason: ModifiedData.bodytemp_missing_reason,
        bodytemp_missing: ModifiedData.bodytemp_missing,
        body_temperature: ModifiedData.body_temperature
          ? parseFloat(ModifiedData.body_temperature)
          : null,
        bloodpressure_missing_reason: ModifiedData.bloodpressure_missing_reason,
        bloodpressure_missing: ModifiedData.bloodpressure_missing,
        blood_pressure: ModifiedData.blood_pressure,
      })
      .then((res) => {
        onToggle("success");
        setTimeout(() => {
          setState({ ...state, success: false });
          setLoading(false);
        }, GlobalNotificationTimer);
      })
      .catch((error) => {
        setErrorNotification(error.response.status);
        onToggle("nosave");
        setTimeout(() => {
          setState({ ...state, nosave: false });
          setLoading(false);
        }, GlobalNotificationTimer);
      });
  };

  const onHeightMissingChange = (e, formRenderProps) => {
    formRenderProps.onChange("height_missing_reason", { value: "" });
    formRenderProps.onChange("height", { value: null });
  };

  const onWeightMissingChange = (e, formRenderProps) => {
    formRenderProps.onChange("weight_missing_reason", { value: "" });
    formRenderProps.onChange("weight", { value: null });
  };
  const onPulseMissingChange = (e, formRenderProps) => {
    formRenderProps.onChange("pulse_missing_reason", { value: "" });
    formRenderProps.onChange("pulse", { value: null });
  };

  const onRespiratoryMissingChange = (e, formRenderProps) => {
    formRenderProps.onChange("respiratory_missing_reason", { value: "" });
    formRenderProps.onChange("respiratory_rate", { value: null });
  };

  const onBodyTempMissingChange = (e, formRenderProps) => {
    formRenderProps.onChange("bodytemp_missing_reason", { value: "" });
    formRenderProps.onChange("body_temperature", { value: null });
  };

  const onBloodPressureMissingChange = (e, formRenderProps) => {
    formRenderProps.onChange("bloodpressure_missing_reason", { value: "" });
    formRenderProps.onChange("blood_pressure", { value: null });
  };

  //SWR ESSENTIAL
  const loadingPanel = (
    <div className="k-loading-mask">
      <span className="k-loading-text">
        {localizationService.toLanguageString("custom.loading")}
      </span>
      <div className="k-loading-image"></div>
      <div className="k-loading-color"></div>
    </div>
  );

  const disabletitle = () => {
    let title = "";
    if (!EditSubject && approved) {
      title = localizationService.toLanguageString("custom.nopermissiontoedit");
    }
    if (!EditSubject) {
      title = localizationService.toLanguageString("custom.nopermissiontoedit");
    } else if (approved) {
      title = localizationService.toLanguageString(
        "custom.thesectionhasbeenapproved"
      );
    } else {
      title = localizationService.toLanguageString("custom.savechanges");
    }
    return title;
  };

  const disablefunction = () => {
    let boolean = false;
    if (!EditSubject || loading || approved) {
      boolean = true;
    }

    return boolean;
  };

  console.log(
    !EditSubject,
    loading,
    approved,
    disablefunction(),
    "fffffffffffff"
  );
  if (error && Noteserror && Attchementserror && checkapproveerror)
    return <>{localizationService.toLanguageString("custom.failedload")}</>;

  return (
    <TrialMap>
      {(!data || !notes || !attachements) && loadingPanel}
      <div className="row">
        <div className="col-12">
          <Card>
            <CardHeader className="DetailFormHeader">
              <div className="row">
                <div className="col DetailCardElementTitle">
                  {localizationService.toLanguageString("custom.subjectid")}
                </div>
                <div className="col DetailCardElementTitle">
                  {localizationService.toLanguageString(
                    "custom.subjectinitials"
                  )}
                </div>
                <div className="col DetailCardElementTitle">
                  {localizationService.toLanguageString("custom.study")}
                </div>
                <div className="col DetailCardElementTitle">
                  {localizationService.toLanguageString("custom.protocolid")}
                </div>
                <div className="col DetailCardElementTitle">
                  {localizationService.toLanguageString("custom.sitenumber")}
                </div>
                <div className="col DetailCardElementTitle">
                  {localizationService.toLanguageString("custom.createdby")}
                </div>
              </div>
              <div className="row">
                <div className="col text-responsive-overflow subject-id-style">
                  {props.location.state ? props.location.state.data.crf_id : ""}
                </div>
                <div className="col text-responsive-overflow">
                  {props.location.state
                    ? props.location.state.data.subject_initial
                    : ""}
                </div>
                <div className="col text-responsive-overflow">
                  {props.location.state
                    ? props.location.state.data.study_name
                    : ""}
                </div>
                <div className="col text-responsive-overflow">
                  {props.location.state
                    ? props.location.state.data.study_protocol
                    : ""}
                </div>
                <div className="col text-responsive-overflow">
                  {props.location.state
                    ? props.location.state.data.subject_center
                    : ""}
                </div>
                <div className="col text-responsive-overflow">
                  {props.location.state
                    ? props.location.state.data.createdBy
                    : ""}
                </div>
              </div>
              <hr className="RowRoleHr" />
              <div className="row">
                <div className="col pages-big-title">
                  <strong>
                    {localizationService.toLanguageString("custom.vitalsigns")}
                  </strong>
                </div>
                <div className="col">
                  <div className="float-right">
                    <Button onClick={goBack} className="back-button-style">
                      {localizationService.toLanguageString("custom.back")}
                    </Button>
                  </div>
                </div>
              </div>
            </CardHeader>
          </Card>
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-12">
          <TabStrip selected={selected} onSelect={handleSelect}>
            <TabStripTab
              title={localizationService.toLanguageString("custom.vitalsigns")}
            >
              <Form
                initialValues={{
                  height_missing: AllData ? AllData.height_missing : false,
                  weight_missing: AllData ? AllData.weight_missing : false,
                  pulse_missing: AllData ? AllData.pulse_missing : false,
                  respiratory_missing: AllData
                    ? AllData.respiratory_missing
                    : false,
                  bodytemp_missing: AllData ? AllData.bodytemp_missing : false,
                  bloodpressure_missing: AllData
                    ? AllData.bloodpressure_missing
                    : false,
                  missing_field_reason: AllData
                    ? AllData.missing_field_reason
                    : "",
                  height_missing_reason: AllData
                    ? AllData.height_missing_reason
                    : "",
                  weight_missing_reason: AllData
                    ? AllData.weight_missing_reason
                    : "",

                  pulse_missing_reason: AllData
                    ? AllData.pulse_missing_reason
                    : "",
                  respiratory_missing_reason: AllData
                    ? AllData.respiratory_missing_reason
                    : "",
                  bodytemp_missing_reason: AllData
                    ? AllData.bodytemp_missing_reason
                    : "",
                  bloodpressure_missing_reason: AllData
                    ? AllData.bloodpressure_missing_reason
                    : "",
                  assessment_date:
                    AllData && AllData.assessment_date
                      ? new Date(AllData.assessment_date)
                      : null,
                  body_temperature: AllData ? AllData.body_temperature : null,
                  height: AllData ? AllData.height : null,
                  weight: AllData ? AllData.weight : null,
                  pulse: AllData ? AllData.pulse : null,
                  respiratory_rate: AllData ? AllData.respiratory_rate : null,
                  body_temperature: AllData ? AllData.body_temperature : null,
                  blood_pressure: AllData ? AllData.blood_pressure : "",
                }}
                ref={MyForm}
                onSubmitClick={CreateVitalSigns}
                key={JSON.stringify(AllData)}
                render={(formRenderProps) => (
                  <FormElement className="">
                    <fieldset className={"k-form-fieldset"}>
                      <Tooltip
                        openDelay={0}
                        anchorElement="target"
                        parentTitle={true}
                        position={"top"}
                      >
                        <Prompt
                          when={PromptFunction(formRenderProps)}
                          message={localizationService.toLanguageString(
                            "custom.promptmessage"
                          )}
                        />
                        <div className="col-6">
                          <div className="row mt-2">
                            <div className="col-6">
                              <strong>
                                {localizationService.toLanguageString(
                                  "custom.informationstatusquestion"
                                )}
                                ?
                              </strong>
                            </div>
                            <div className="col-3">
                              {" "}
                              <RadioButton
                                name="radio1"
                                value="yes"
                                checked={radioValue === "yes"}
                                label={localizationService.toLanguageString(
                                  "custom.yes"
                                )}
                                onChange={(e) =>
                                  handleRadio1Change(e, formRenderProps)
                                }
                                // disabled={
                                //   AllData && AllData.missing_field === false
                                //     ? true
                                //     : false
                                // }
                              />
                            </div>
                            <div className="col-3">
                              {" "}
                              <RadioButton
                                name="radio2"
                                value="no"
                                checked={radioValue === "no"}
                                label={localizationService.toLanguageString(
                                  "custom.no"
                                )}
                                onChange={(e) =>
                                  handleRadio2Change(e, formRenderProps)
                                }
                                // disabled={
                                //   AllData && AllData.missing_field === false
                                //     ? true
                                //     : false
                                // }
                              />
                            </div>
                            {radioValue === "yes" ? (
                              <div className="row">
                                <div className="col">
                                  <Field
                                    name={"missing_field_reason"}
                                    label={localizationService.toLanguageString(
                                      "custom.missingreason"
                                    )}
                                    validator={requiredValidator}
                                    component={RequiredFormTextArea}
                                  />
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                          {radioValue === "no" ? (
                            <>
                              <div className="row">
                                <div className="col-6">
                                  <Field
                                    id={"assessment_date"}
                                    name={"assessment_date"}
                                    label={localizationService.toLanguageString(
                                      "custom.dateofassessment"
                                    )}
                                    component={RequiredFormDatePicker}
                                    validator={requiredValidator}
                                  />
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-4">
                                  <Field
                                    className="checkbox-margintop"
                                    id={"height_missing"}
                                    name={"height_missing"}
                                    component={FormCheckbox}
                                    label={localizationService.toLanguageString(
                                      "custom.height"
                                    )}
                                    onChange={(e) =>
                                      onHeightMissingChange(e, formRenderProps)
                                    }
                                  />
                                </div>

                                {formRenderProps.valueGetter(
                                  "height_missing"
                                ) === false ? (
                                  <div className="col-7">
                                    <Field
                                      name={"height_missing_reason"}
                                      label={localizationService.toLanguageString(
                                        "custom.missingreason"
                                      )}
                                      validator={requiredValidator}
                                      component={RequiredFormTextArea}
                                      rows={1}
                                    />
                                  </div>
                                ) : (
                                  <div className="col-7">
                                    <Field
                                      id={"height"}
                                      name={"height"}
                                      label={localizationService.toLanguageString(
                                        "custom.height"
                                      )}
                                      hint={localizationService.toLanguageString(
                                        "custom.cm"
                                      )}
                                      validator={requiredValidator}
                                      component={RequiredFormNumericTextBox}
                                      min={0}
                                      format={"n0"}
                                    />
                                  </div>
                                )}
                              </div>

                              <div className="row">
                                <div className="col-4">
                                  <Field
                                    className="checkbox-margintop"
                                    id={"weight_missing"}
                                    name={"weight_missing"}
                                    component={FormCheckbox}
                                    label={localizationService.toLanguageString(
                                      "custom.weight"
                                    )}
                                    onChange={(e) =>
                                      onWeightMissingChange(e, formRenderProps)
                                    }
                                  />
                                </div>
                                <div className="col-7">
                                  {formRenderProps.valueGetter(
                                    "weight_missing"
                                  ) === false ? (
                                    <Field
                                      name={"weight_missing_reason"}
                                      label={localizationService.toLanguageString(
                                        "custom.missingreason"
                                      )}
                                      validator={requiredValidator}
                                      component={RequiredFormTextArea}
                                      rows={1}
                                    />
                                  ) : (
                                    <Field
                                      id={"weight"}
                                      name={"weight"}
                                      label={localizationService.toLanguageString(
                                        "custom.weight"
                                      )}
                                      hint={localizationService.toLanguageString(
                                        "custom.kg"
                                      )}
                                      validator={requiredValidator}
                                      placeholder={"---.-"}
                                      component={RequiredFormNumericTextBox}
                                      min={0}
                                      format={"n1"}
                                    />
                                  )}
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-4">
                                  <Field
                                    className="checkbox-margintop"
                                    id={"pulse_missing"}
                                    name={"pulse_missing"}
                                    component={FormCheckbox}
                                    label={localizationService.toLanguageString(
                                      "custom.pulse"
                                    )}
                                    onChange={(e) =>
                                      onPulseMissingChange(e, formRenderProps)
                                    }
                                  />
                                </div>
                                <div className="col-7">
                                  {formRenderProps.valueGetter(
                                    "pulse_missing"
                                  ) === false ? (
                                    <Field
                                      name={"pulse_missing_reason"}
                                      label={localizationService.toLanguageString(
                                        "custom.missingreason"
                                      )}
                                      validator={requiredValidator}
                                      component={RequiredFormTextArea}
                                      rows={1}
                                    />
                                  ) : (
                                    <Field
                                      id={"pulse"}
                                      name={"pulse"}
                                      label={localizationService.toLanguageString(
                                        "custom.pulse"
                                      )}
                                      hint={localizationService.toLanguageString(
                                        "custom.beatspermin"
                                      )}
                                      validator={requiredValidator}
                                      component={RequiredFormNumericTextBox}
                                      min={0}
                                      format={"n0"}
                                    />
                                  )}
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-4">
                                  <Field
                                    className="checkbox-margintop"
                                    id={"respiratory_missing"}
                                    name={"respiratory_missing"}
                                    component={FormCheckbox}
                                    label={localizationService.toLanguageString(
                                      "custom.respiratoryrate"
                                    )}
                                    onChange={(e) =>
                                      onRespiratoryMissingChange(
                                        e,
                                        formRenderProps
                                      )
                                    }
                                  />
                                </div>
                                <div className="col-7">
                                  {formRenderProps.valueGetter(
                                    "respiratory_missing"
                                  ) === false ? (
                                    <Field
                                      name={"respiratory_missing_reason"}
                                      label={localizationService.toLanguageString(
                                        "custom.missingreason"
                                      )}
                                      validator={requiredValidator}
                                      component={RequiredFormTextArea}
                                      rows={1}
                                    />
                                  ) : (
                                    <Field
                                      id={"respiratory_rate"}
                                      name={"respiratory_rate"}
                                      label={localizationService.toLanguageString(
                                        "custom.respiratoryrate"
                                      )}
                                      hint={localizationService.toLanguageString(
                                        "custom.breathspermin"
                                      )}
                                      validator={requiredValidator}
                                      component={RequiredFormNumericTextBox}
                                      min={0}
                                      format={"n0"}
                                    />
                                  )}
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-4">
                                  <Field
                                    className="checkbox-margintop"
                                    id={"bodytemp_missing"}
                                    name={"bodytemp_missing"}
                                    component={FormCheckbox}
                                    label={localizationService.toLanguageString(
                                      "custom.bodytemperature"
                                    )}
                                    onChange={(e) =>
                                      onBodyTempMissingChange(
                                        e,
                                        formRenderProps
                                      )
                                    }
                                  />
                                </div>
                                <div className="col-7">
                                  {formRenderProps.valueGetter(
                                    "bodytemp_missing"
                                  ) === false ? (
                                    <Field
                                      name={"bodytemp_missing_reason"}
                                      label={localizationService.toLanguageString(
                                        "custom.missingreason"
                                      )}
                                      validator={requiredValidator}
                                      component={RequiredFormTextArea}
                                      rows={1}
                                    />
                                  ) : (
                                    <Field
                                      id={"body_temperature"}
                                      name={"body_temperature"}
                                      label={localizationService.toLanguageString(
                                        "custom.bodytemperature"
                                      )}
                                      hint={localizationService.toLanguageString(
                                        "custom.celcius"
                                      )}
                                      placeholder={"--.-"}
                                      component={RequiredFormNumericTextBox}
                                      validator={requiredValidator}
                                      min={0}
                                      format={"n1"}
                                    />
                                  )}
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-4">
                                  <Field
                                    className="checkbox-margintop"
                                    id={"bloodpressure_missing"}
                                    name={"bloodpressure_missing"}
                                    component={FormCheckbox}
                                    label={localizationService.toLanguageString(
                                      "custom.bloodpressure"
                                    )}
                                    onChange={(e) =>
                                      onBloodPressureMissingChange(
                                        e,
                                        formRenderProps
                                      )
                                    }
                                  />
                                </div>
                                <div className="col-7">
                                  {formRenderProps.valueGetter(
                                    "bloodpressure_missing"
                                  ) === false ? (
                                    <Field
                                      name={"bloodpressure_missing_reason"}
                                      label={localizationService.toLanguageString(
                                        "custom.missingreason"
                                      )}
                                      validator={requiredValidator}
                                      component={RequiredFormTextArea}
                                      rows={1}
                                    />
                                  ) : (
                                    <Field
                                      id={"blood_pressure"}
                                      name={"blood_pressure"}
                                      label={localizationService.toLanguageString(
                                        "custom.bloodpressure"
                                      )}
                                      hint={localizationService.toLanguageString(
                                        "custom.mmhg"
                                      )}
                                      placeholder={"---/---"}
                                      component={RequiredFormInput}
                                      validator={bloodpressureValidator}
                                    />
                                  )}
                                </div>
                              </div>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                      </Tooltip>
                    </fieldset>
                    <Tooltip
                      openDelay={0}
                      anchorElement="target"
                      parentTitle={true}
                      position={"left"}
                    >
                      <div className="float-right">
                        <div title={disabletitle()}>
                          <Button
                            primary={true}
                            type={"submit"}
                            className="mr-2em"
                            disabled={disablefunction()}
                          >
                            {loading
                              ? localizationService.toLanguageString(
                                  "custom.loading"
                                )
                              : localizationService.toLanguageString(
                                  "custom.save"
                                )}
                          </Button>
                        </div>
                      </div>
                    </Tooltip>
                  </FormElement>
                )}
              />
            </TabStripTab>
            <TabStripTab
              title={localizationService.toLanguageString(
                "custom.approvesection"
              )}
            >
              <ApproveStudySubject
                study_subject={props.location.state.data.id}
                section={props.location.state.section.id}
                data={props.location.state.data}
                parentCallBack={ChangeApproveSection}
              />
            </TabStripTab>

            <TabStripTab
              title={localizationService.toLanguageString(
                "custom.notesnattachements"
              )}
            >
              <TabStrip selected={Subselected} onSelect={handleSubSelect}>
                <TabStripTab
                  title={localizationService.toLanguageString("custom.notes")}
                >
                  <GridTelerik data={notes}>
                    <GridToolbar>
                      <Button
                        primary={true}
                        onClick={() => {
                          {
                            EditSubject
                              ? toggleDaddNote()
                              : toggleDPermission();
                          }
                        }}
                      >
                        {localizationService.toLanguageString("custom.new")}
                      </Button>
                    </GridToolbar>

                    <Column
                      field={"note"}
                      title={localizationService.toLanguageString(
                        "custom.note"
                      )}
                      cell={NoteNameTemplate}
                    />
                    <Column
                      field={"date_created"}
                      title={localizationService.toLanguageString(
                        "custom.datecreated"
                      )}
                      cell={DateCreatedTemplate}
                    />
                    <Column
                      title={localizationService.toLanguageString(
                        "custom.actions"
                      )}
                      width="100px"
                      cell={Noteactions}
                    />
                  </GridTelerik>
                </TabStripTab>

                <TabStripTab
                  title={localizationService.toLanguageString(
                    "custom.attachements"
                  )}
                >
                  <GridTelerik data={attachements}>
                    <GridToolbar>
                      <Button
                        primary={true}
                        onClick={() => {
                          {
                            EditSubject
                              ? toggleDaddFile()
                              : toggleDPermission();
                          }
                        }}
                      >
                        {localizationService.toLanguageString("custom.new")}
                      </Button>
                    </GridToolbar>
                    <Column
                      field={"title"}
                      title={localizationService.toLanguageString(
                        "custom.title"
                      )}
                    />

                    <Column
                      field={"date_created"}
                      title={localizationService.toLanguageString(
                        "custom.dateadded"
                      )}
                      cell={DateCreatedTemplate}
                    />

                    <Column
                      title={localizationService.toLanguageString(
                        "custom.actions"
                      )}
                      width="100px"
                      cell={Fileactions}
                    />
                  </GridTelerik>
                </TabStripTab>
              </TabStrip>
            </TabStripTab>
          </TabStrip>
        </div>
      </div>

      <NotificationGroup style={position.topCenter}>
        <Fade>
          {nosave && (
            <Notification
              type={{
                style: "error",
                icon: true,
              }}
              closable={true}
              onClose={() => setState({ ...state, nosave: false })}
            >
              <span>
                {ErrorNotification}{" "}
                {localizationService.toLanguageString("custom.errornosave")}
              </span>
            </Notification>
          )}
        </Fade>
        <Fade>
          {nomodify && (
            <Notification
              type={{
                style: "warning",
                icon: true,
              }}
              closable={true}
              onClose={() => setState({ ...state, nomodify: false })}
            >
              <span>
                {localizationService.toLanguageString(
                  "custom.nomodificationchange"
                )}
              </span>
            </Notification>
          )}
        </Fade>
        <Fade>
          {success && (
            <Notification
              type={{
                style: "success",
                icon: true,
              }}
              closable={true}
              onClose={() => setState({ ...state, success: false })}
            >
              <span>
                {localizationService.toLanguageString("custom.datasaved")}
              </span>
            </Notification>
          )}
        </Fade>
      </NotificationGroup>
      {/* MODIFY REASON DIALOG */}
      {VModifyreason && (
        <Dialog
          title={localizationService.toLanguageString(
            "custom.modificationreason"
          )}
          onClose={toggleDModifyreason}
          width={"700px"}
        >
          <div>
            <p style={{ margin: "25px", textAlign: "center" }}>
              {localizationService.toLanguageString(
                "custom.pleasespecifymodifyreason"
              )}
            </p>
            <Form
              initialValues={{
                modification_reason: "",
              }}
              onSubmit={CreateModification}
              render={(formRenderProps) => (
                <FormElement className="">
                  <fieldset className={"k-form-fieldset"}>
                    <div className="row">
                      <div className="col-12">
                        <Field
                          id={"modification_reason"}
                          name={"modification_reason"}
                          label={localizationService.toLanguageString(
                            "custom.reason"
                          )}
                          validator={requiredValidator}
                          component={RequiredFormTextArea}
                        />
                      </div>
                    </div>

                    <div className="row mb-2 mt-2">
                      <div className="col-12">
                        <div className="float-right">
                          <Button
                            primary={true}
                            type={"submit"}
                            className="mr-2em"
                          >
                            {localizationService.toLanguageString(
                              "custom.save"
                            )}
                          </Button>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </FormElement>
              )}
            />
          </div>
        </Dialog>
      )}

      {/* PERMISSION DIALOG */}
      {VPermission && (
        <Dialog
          title={localizationService.toLanguageString(
            "custom.permissiondenied"
          )}
          onClose={toggleDPermission}
        >
          <PermissionDenied onClose={toggleDPermission} />
        </Dialog>
      )}

      {VaddNote && (
        <Dialog
          width="700px"
          title={localizationService.toLanguageString("custom.addnote")}
          onClose={toggleDaddNote}
        >
          <AddNote
            onClose={toggleDaddNote}
            section={props.location.state.section.id}
            subject={props.location.state.data.id}
          />
        </Dialog>
      )}
      {VeditNote && (
        <Dialog
          width="700px"
          title={localizationService.toLanguageString("custom.editnote")}
          onClose={toggleDeditNote}
        >
          <AddNote onClose={toggleDeditNote} data={EditNote} />
        </Dialog>
      )}
      {Vdelete && (
        <Dialog
          title={localizationService.toLanguageString("custom.confirm")}
          onClose={toggleDdelete}
        >
          <DeleteObject onClose={toggleDdelete} Name={Name} api={DeleteAPI} />
        </Dialog>
      )}

      {VaddFile && (
        <Dialog
          width="600px"
          title={localizationService.toLanguageString("custom.upload")}
          onClose={toggleDaddFile}
        >
          <AddFile
            onClose={toggleDaddFile}
            section={props.location.state.section.id}
            subject={props.location.state.data.id}
          />
        </Dialog>
      )}
      {VTabStripChange && (
        <Dialog
          title={localizationService.toLanguageString("custom.confirm")}
          onClose={toggleDTabStripChange}
        >
          <TabChange
            selected={selectedTab}
            parentCallBack={TabCallBack}
            onClose={toggleDTabStripChange}
          />
        </Dialog>
      )}
    </TrialMap>
  );
}

export default ListVitalSigns;
